import { createStyles } from '@mantine/core';

import { isDarkMode } from '~/config/themeUtils';

const useStyles = createStyles(
  (
    theme,
    { isStatic, actionBannerColor = 'red' }: { isStatic?: boolean; actionBannerColor?: string } = {}
  ) => ({
    container: {
      padding: theme.spacing.md,
      transition: 'transform ease-in-out 200ms',

      ...(isDarkMode(theme) ? {} : { border: `1px solid ${theme.colors.gray[2]}` }),

      ...(!isStatic ? { cursor: 'pointer', '&:hover': { transform: 'scale(1.02)' } } : {}),
    },
    top: {
      flexWrap: 'nowrap',
    },
    headerWrapper: {
      flex: 1,
      minWidth: 0,
      flexWrap: 'nowrap',
    },
    titleWrapper: {
      overflow: 'hidden',
      minWidth: 0,
      maxWidth: '100%',
      flexWrap: 'nowrap',
    },
    infoItemLabel: {
      fontSize: theme.fontSizes.xs,
      lineHeight: '18px',
    },
    infoItemValue: {
      fontWeight: 600,
      fontSize: theme.fontSizes.sm,
      lineHeight: '22px',
    },
    menu: {
      position: 'absolute',
      right: 4,
      top: 6,
    },
    actionBanner: {
      background: theme.colors.red[1],
      color: theme.colors.red[9],
      padding: /* eslint-disable-line local-rules/use-theme-tokens */ 5,
      fontWeight: 600,
      fontSize: theme.fontSizes.xs,
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: theme.radius.md,

      ...(() => {
        switch (actionBannerColor) {
          case 'red':
            return {
              background: theme.colors.red[3],
              color: 'white',
            };
          case 'yellow':
            return {
              background: theme.colors.yellow[4],
              color: theme.colors.gray[9],
            };
          case 'gray':
          default:
            return {
              background: theme.colors.gray[3],
              color: theme.colors.gray[9],
            };
        }
      })(),
    },
    liveDot: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      backgroundColor: theme.colors.green[6],
    },
    titleContainerSkeleton: {
      width: '100%',
    },
  })
);

export default useStyles;
